import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as statisticsReducer from '../reducer';
import * as statisticsActionMgr from '../action-mgr';
import * as strings from '../../helpers/strings';
import { Grid, Button } from '@material-ui/core';
import '../../index.css';
import Page from '../../common-components/Page';
import StationStatisticsForm from './StationStatisticsForm';
import StationStatisticsFormBiDirectionalEnergy from './StationStatisticsFormBiDirectionalEnergy';
import StationStatisticsGraph from './StationStatisticsGraph';
import StationStatisticsGraphBiDirectionalEnergy from './StationStatisticsGraphBiDirectionalEnergy';
import StationStatisticsTotalize from './StationStatisticsTotalize'; 
import StationStatisticsPortfolioTotalize from './StationStatisticsPortfolioTotalize'; 
import StationStatisticsPortfolioForm from './StationStatisticsPortfolioForm';
import StationStatisticsPortfolioGraph from './StationStatisticsPortfolioGraph';

const styles = {
  tabButton: {
    fontSize: '1rem',
    fontWeight: 500,
    textTransform: 'capitalize',
    padding: '15px 78px',
    cursor: 'pointer',
    borderRadius: '4px',
    backgroundColor: '#fff',
    marginRight: '15px',
    marginBottom: '10px',

    border: '1px solid #ccc',
    backgroundColor: '#f0f0f0',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    }
  },
  activeTab: {
    color: '#fff',
    backgroundColor: '#343A40',
    border: '1px solid #343A40',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
    '&:hover': {
      color: '#343A40',
      backgroundColor: '#fff',
    }
  },
  inactiveTab: {
    backgroundColor: '#ffffff',
  },
};

class StationStatisticsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentYear: new Date().getFullYear(),
      activeTab: 'Portfolio Analysis', // Default to "Statistical Analysis"
    };
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const { statisticsTotalize, portfolioTotalize, classes } = this.props;
    const { activeTab } = this.state;

    return (
      <Page title={strings.lblStatistics} >
        <Grid container spacing={8} >
          {activeTab === 'Portfolio Analysis' && (
              <Grid item md={12} sm={12} xs={12}>
                <StationStatisticsPortfolioTotalize portfolioTotalize={portfolioTotalize} currentYear={this.state.currentYear} />
              </Grid>
          )}     
          { (activeTab === 'Statistical Analysis' || activeTab === 'Bi Directional Energy') && (
            <Grid item md={12} sm={12} xs={12}>
              <StationStatisticsTotalize statisticsTotalize={statisticsTotalize} currentYear={this.state.currentYear} />
            </Grid>
          )}
          {/* <Grid item md={2} sm={12} xs={12}>
            <StationSelect />
          </Grid> */}
          <Grid item md={12} sm={12} xs={12}>
              <Button
                className={`${classes.tabButton} ${activeTab === 'Portfolio Analysis' ? classes.activeTab : ''}`}
                onClick={() => this.handleTabChange('Portfolio Analysis')}
              >
                Portfolio Analysis 
                (Beta)
              </Button>
              <Button
                className={`${classes.tabButton} ${activeTab === 'Statistical Analysis' ? classes.activeTab : ''}`}
                onClick={() => this.handleTabChange('Statistical Analysis')}
              >
                Individual Statistical Analysis
              </Button>
              <Button
                className={`${classes.tabButton} ${activeTab === 'Bi Directional Energy' ? classes.activeTab : ''}`}
                onClick={() => this.handleTabChange('Bi Directional Energy')}
              >
                Bi Directional Energy
              </Button>
          </Grid>

          {activeTab === 'Portfolio Analysis' && (
            <>
              <Grid item md={2} sm={12} xs={12}>
                <StationStatisticsPortfolioForm />
              </Grid>
              <Grid item md={10} sm={12} xs={12}>
                <div style={{ overflowY: 'auto', height: '80vh', scrollBehavior: 'smooth' }}>
                  <StationStatisticsPortfolioGraph />
                </div>
              </Grid>
            </>
          )}

          {activeTab === 'Statistical Analysis' && (
            <>
              <Grid item md={2} sm={12} xs={12}>
                <StationStatisticsForm />
              </Grid>
              <Grid item md={10} sm={12} xs={12}>
                <div style={{ overflowY: 'auto', height: '80vh', scrollBehavior: 'smooth' }}>
                  <StationStatisticsGraph />
                </div>
              </Grid>
            </>
          )}

          {activeTab === 'Bi Directional Energy' && (
            <>
              <Grid item md={2} sm={12} xs={12}>
                <StationStatisticsFormBiDirectionalEnergy />
              </Grid>
              <Grid item md={10} sm={12} xs={12}>
                <div style={{ overflowY: 'auto', height: '80vh', scrollBehavior: 'smooth' }}>
                <StationStatisticsGraphBiDirectionalEnergy />
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  selectedStationName: statisticsReducer.getSelectedStatisticsStationName(state),
  stationTimeOffset: statisticsReducer.getStationTimeOffset(state),
  statisticsTotalize: statisticsReducer.getStatisticsTotalize(state),
  portfolioTotalize: statisticsReducer.getPortfolioTotalize(state),
});

const mapActionsToProps = {
  setSelectStatisticsStation: statisticsActionMgr.setSelectStatisticsStation,
  getStationTimeOffset: statisticsActionMgr.getStationTimeOffset,
  setSelectYear: statisticsActionMgr.setSelectYear,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withRouter(withStyles(styles)(StationStatisticsScreen))
);
